import { render, staticRenderFns } from "./GrupoConfig.vue?vue&type=template&id=0c6f260e&scoped=true"
import script from "./GrupoConfig.vue?vue&type=script&lang=js"
export * from "./GrupoConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f260e",
  null
  
)

export default component.exports